import { html, LitElement } from 'lit';
import styles from './Spinner.styles.js';
/**
 * @since 0.1
 * @status cc-clone
 *
 * A loading indicator, auto centered and with flexible size.
 *
 * ## Details
 *
 * * Size this component like you want, the loading circle will be centered automatically.
 *
 * @cssdisplay flex
 * *
 * credits: https://github.com/CleverCloud/clever-components/blob/master/src/atoms/cc-loader.js
 */
export class SgdfSpinner extends LitElement {
    render() {
        return html `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="20 20 40 40">
                <circle cx="40px" cy="40px" r="16px"></circle>
            </svg>
        `;
    }
}
SgdfSpinner.styles = styles;
//# sourceMappingURL=Spinner.js.map